/* eslint-disable array-callback-return */
import React, { useEffect, useState } from "react";
import AddEditPerson from "./AddEditPerson";
import { getAllPerson, getPersonByID, handlePersonDelete } from "../../Redux/PersonSlice";
import { useDispatch, useSelector } from "react-redux";
import { BiEdit } from "react-icons/bi";
import { MdDeleteForever } from "react-icons/md";
import { BsThreeDotsVertical } from "react-icons/bs";
import { IoSearch } from "react-icons/io5";
import { useNavigate } from "react-router";
import Loading from "../Common/Loading";
import sweetAlert from "../Common/sweetAlert";
import { FaPlus } from "react-icons/fa6";
import { RxDotsHorizontal } from "react-icons/rx";
import * as XLSX from 'xlsx';
import axios from "axios";
import { IMPORT_PERSON } from "../Common/API";
import toast from "react-hot-toast";
import Pagination from "../Common/Pagination";

import { getMenuAll, getMenuPermission } from "../../Redux/SideBarSlice";

const People = ({
  isVisible,
  setIsVisible,
  setSidebarOpen,
  sidebarOpen,
  isDark,
  setIsDark,
}) => {

  const dispatch = useDispatch()
  const navigate = useNavigate();
  const { token, user } = useSelector((state) => state.root.auth);
  const authToken = `Bearer ${token}`;
  const store = useSelector((state) => state?.root?.Person);
  const [openModel, setOpenModel] = useState(false);
  const [Person, setPerson] = useState([]);
  const [loading, setloading] = useState(true);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedPepoleIds, setSelectedPepoleIds] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sortedField, setSortedField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [loadFirst, setloadFirst] = useState(true);
  const [AciteOption, setAciteOption] = useState(false);
  const [openActionMenuId, setOpenActionMenuId] = useState(null);
  const [permissions, setPermissions] = useState({
    isDelete: false,
    isSave: false,
    isView: false,
  });

  useEffect(() => {
    const handleOutsideClick = () => setOpenActionMenuId(null);
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, [dispatch, user?.userRoleID]);

  useEffect(() => {
    dispatch(getMenuAll()).then((item) => {

      const findData = item.payload?.data?.menu.reduce((result, menuItem) => {
        if (menuItem.submenu && Array.isArray(menuItem.submenu)) {
          const submenuItem = menuItem.submenu.find((submenuItem) => submenuItem.pageName === "People");
          if (submenuItem) { result = submenuItem; }
        }
        return result;
      }, null);

      if (findData) {
        const ItemID = findData.moduleID;
        const payload = { UserRoleID: user.userRoleID, ModuleID: ItemID };
        dispatch(getMenuPermission(payload)).then((permissionItem) => {
          // console.log('permissionItem :>> ', permissionItem);
          if (Array.isArray(permissionItem?.payload?.data) && permissionItem?.payload?.data?.length > 0) {
            setPermissions(permissionItem?.payload?.data[0]);
          }
        });
      }
    });
  }, [dispatch, user?.userRoleID]);

  useEffect(() => {
    if (loadFirst) {
      setloading(true)
      dispatch(getAllPerson({})).then((res) => {
        const timer = setTimeout(() => {
          setloading(false)
        }, 1000);

        return () => clearTimeout(timer);
      }).catch((error) => {
        console.log('error :>> ', error);
      })
      setloadFirst(false)
    }
  }, [loadFirst, dispatch])

  useEffect(() => {
    setCurrentPage(1)
  }, [searchTerm]);

  const togglemodel = () => {
    setOpenModel(!openModel);
    setPerson([]);
  };

  const handleSort = (field) => {
    if (sortedField === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortOrder("asc");
      setSortedField(field);
    }
  };

  const sortData = (data, field, order) => {
    const sortedData = [...data];
    sortedData.sort((a, b) => {
      const aTrimmed = a[field]?.trim() || '';
      const bTrimmed = b[field]?.trim() || '';
      if (order === "asc") {
        return aTrimmed?.localeCompare(bTrimmed);
      }
    });
    return sortedData;
  };

  const peopleList = Array.isArray(store?.getAllPerson) ? store.getAllPerson : [];
  const filteredPeople = peopleList.filter((item) =>
    (item?.name || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  const [rowsPerPage, setrowsPerPage] = useState(10);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = sortData(filteredPeople, sortedField, sortOrder).slice(indexOfFirstRow, indexOfLastRow)
  const totalPages = Math.ceil(filteredPeople.length / rowsPerPage);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleDeleteUser = async () => {
    try {
      const result = await sweetAlert.confirm("Are you sure?", "You won't be able to revert this!");
      if (result.isConfirmed) {
        await dispatch(handlePersonDelete(selectedPepoleIds)).then((res) => {
          if (res.payload.status === true) {
            setloadFirst(true)
            setSelectedPepoleIds([])
            setCurrentPage(1)
            setCurrentPage(1)
          }
          setSelectAll(false);
          sweetAlert.success("Deleted successfully");
        });
      }

    } catch (error) {
      console.error("Error:", error);
      sweetAlert.error("An error occurred");
    }
  };

  // selected row 
  const handleCheckboxChange = (productId) => {
    let updatedSelectedProductIds;

    if (selectedPepoleIds.includes(productId)) {
      updatedSelectedProductIds = selectedPepoleIds.filter((id) => id !== productId);
    } else {
      updatedSelectedProductIds = [...selectedPepoleIds, productId];
    }
    setSelectedPepoleIds(updatedSelectedProductIds);
    const allRowsSelected = updatedSelectedProductIds.length === filteredPeople.length;
    setSelectAll(allRowsSelected);
  };


  const handleSelectAll = () => {
    setSelectAll(!selectAll);

    if (!selectAll) {
      const allProductIds = filteredPeople.map((item) => item.personMasterID);
      setSelectedPepoleIds(allProductIds);
    } else {
      setSelectedPepoleIds([]);
    }
  };
  const EditPerson = async (id) => {
    console.log("🚀 ~ EditPerson ~ id:", id)
    const result = await dispatch(getPersonByID(id));
    if (result) {
      setPerson(result?.payload?.data);
    }
  };

  const handleExport = () => {
    const data = store?.getAllPerson?.map(item => ({
      Name: item.name,
      LabelName: item.labelName,
      VisibleToName: item.visibleName,
      OrganizationName: item.organizationName,
      LeadTitle: item.peopleName,
      DealTitle: item.deal,
      ProjectName: '',
      ProductName: '',
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Leads");
    XLSX.writeFile(workbook, "people_data.xlsx");
    setAciteOption(!AciteOption)
  };

  const uploadExcel = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('ExcelFilePath', file);

    try {
      const response = await axios.post(IMPORT_PERSON, formData, {
        headers: { Authorization: authToken, 'Content-Type': 'multipart/form-data' },
      });

      if (response.data.status === true) {
        setAciteOption(!AciteOption)
        toast.success(response?.data?.message)
      }
    } catch (error) {
      console.error('Upload error:', error);
    }
  };

  const totalPeople = peopleList.length;
  const wonDealsPeople = peopleList.filter((p) => p?.wonDeal > 0).length;
  const openDealsPeople = peopleList.filter((p) => p?.openDeal > 0).length;
  const totalDealsLinked = peopleList.reduce((acc, p) => acc + (p?.openDeal || 0) + (p?.wonDeal || 0) + (p?.lostDeal || 0), 0);

  return (
    <>
      <div className="flex flex-1">
        <div className="page-wrapper relative ml-auto w-[calc(100%-326px)] px-4 pt-[54px] duration-300">
          
          {/* Page Header */}
          <div className="crm-page-header">
            <div className="flex items-center justify-between">
              <div>
                <h1 className="crm-page-title">People</h1>
                <ol className="crm-breadcrumb">
                  <li><a href="/Analytics">Disploy</a></li>
                  <li>/</li>
                  <li>CRM</li>
                  <li>/</li>
                  <li className="active">People</li>
                </ol>
              </div>
              {permissions?.isSave && (
                <button className="crm-new-btn" onClick={() => setOpenModel(true)}>
                  <FaPlus size={11} />
                  New Person
                </button>
              )}
            </div>
          </div>

          <div className="xl:w-full min-h-[calc(100vh-138px)] relative pb-14">
            
            {/* Stat Cards */}
            <div className="crm-stats-row">
              <div className="crm-stat-card crm-card-indigo">
                <div className="flex items-start gap-3">
                  <div className="stat-icon stat-icon-indigo">
                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                      <circle cx="9" cy="7" r="4" />
                      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                  </div>
                  <div>
                    <p className="stat-label">Total People</p>
                    <p className="stat-value">{totalPeople}</p>
                    <p className="stat-trend-up">↑ 8% vs last month</p>
                  </div>
                </div>
              </div>
              <div className="crm-stat-card crm-card-green">
                <div className="flex items-start gap-3">
                  <div className="stat-icon stat-icon-green">
                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </div>
                  <div>
                    <p className="stat-label">Won Deals Contacts</p>
                    <p className="stat-value">{wonDealsPeople}</p>
                    <p className="stat-trend-up">↑ 10% vs last month</p>
                  </div>
                </div>
              </div>
              <div className="crm-stat-card crm-card-blue">
                <div className="flex items-start gap-3">
                  <div className="stat-icon stat-icon-blue">
                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="10" />
                      <path d="M12 6v6l4 2" />
                    </svg>
                  </div>
                  <div>
                    <p className="stat-label">Open Deals Contacts</p>
                    <p className="stat-value">{openDealsPeople}</p>
                    <p className="stat-trend-up">↑ 15% vs last month</p>
                  </div>
                </div>
              </div>
              <div className="crm-stat-card crm-card-orange">
                <div className="flex items-start gap-3">
                  <div className="stat-icon stat-icon-orange">
                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                      <rect x="2" y="3" width="20" height="14" rx="2" />
                      <path d="M8 21h8M12 17v4" />
                    </svg>
                  </div>
                  <div>
                    <p className="stat-label">Total Deals Linked</p>
                    <p className="stat-value">{totalDealsLinked}</p>
                    <p className="stat-trend-up">↑ 12% vs last month</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="crm-panel">

              {loading && (
                <div className="h-screen">
                  <Loading />
                </div>
              )}
              {!loading && (
                <>
                  <div className="flex items-center justify-end px-4 py-3 border-b border-slate-100 gap-3 flex-wrap">
                    <div className="crm-search-box">
                      <IoSearch size={14} />
                      <input
                        type="text"
                        placeholder="Search people..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>

                    {permissions?.isDelete && selectedPepoleIds && selectedPepoleIds.length > 0 && (
                      <button
                        className="p-2 rounded-lg text-red-500 hover:bg-red-50 transition-colors"
                        onClick={handleDeleteUser}
                        title="Delete Selected"
                      >
                        <MdDeleteForever size={18} />
                      </button>
                    )}

                    <div className="relative">
                      <button
                        type="button"
                        className="p-2 hover:bg-slate-50 border border-slate-200 rounded-lg text-slate-500 hover:text-slate-800 transition-colors"
                        onClick={() => setAciteOption(!AciteOption)}
                      >
                        <RxDotsHorizontal size={16} />
                      </button>
                      {AciteOption && (
                        <div className="absolute right-0 mt-1 w-44 bg-white border border-slate-100 rounded-lg shadow-lg py-1 z-50 text-left">
                          {currentRows.length > 0 && (
                            <button
                              onClick={handleExport}
                              className="w-full text-left px-4 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors"
                            >
                              Export file results
                            </button>
                          )}
                          <label className="w-full text-left px-4 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors cursor-pointer block">
                            <input
                              type="file"
                              className="hidden"
                              onChange={uploadExcel}
                              accept=".xls,.xlsx"
                            />
                            Import Data
                          </label>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="relative scroll-inner">
                    <table className="crm-table">
                      <thead>
                        <tr className="text-center">
                          {permissions?.isDelete && (
                            <th scope="col" className="w-4 p-4 text-center">
                              <label className="custom-label">
                                <div className="bg-white dark:bg-slate-600/40 border border-slate-300 dark:border-slate-600 rounded w-4 h-4 inline-block leading-4 -mb-[3px]">
                                  <input
                                    type="checkbox"
                                    checked={selectAll}
                                    onChange={() => handleSelectAll()}
                                  />
                                </div>
                              </label>
                            </th>
                          )}
                          <th scope="col" className="mw-200 p-4">
                            <div className="flex justify-center items-center w-full">
                              Name
                              <svg
                                className="w-3 h-3 ms-1.5 cursor-pointer"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                viewBox="0 0 24 24"
                                onClick={() => handleSort("name")}
                              >
                                <path
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Zm-6.852 0 3.426 5.05-3.426-5.05Z"
                                />
                              </svg>
                            </div>
                          </th>
                          <th scope="col" className="mw-200 p-4">Label</th>
                          <th scope="col" className="mw-200 p-4">Organization</th>
                          <th scope="col" className="mw-200 p-4">Email</th>
                          <th scope="col" className="mw-200 p-4">Phone</th>
                          <th scope="col" className="mw-200 p-4">Won deals</th>
                          <th scope="col" className="mw-200 p-4">Lost deals</th>
                          <th scope="col" className="mw-200 p-4">Closed deals</th>
                          <th scope="col" className="mw-200 p-4">Open deals</th>
                          {/* <th scope="col" className="mw-200 p-4">Done activities</th>
                          <th scope="col" className="mw-200 p-4">Activities to do</th>
                          <th scope="col" className="mw-200 p-4">Total activities</th>
                          <th scope="col" className="mw-200 p-4">Next activity date</th>
                          <th scope="col" className="mw-200 p-4">Person Created</th>
                          <th scope="col" className="mw-200 p-4">Update time</th>
                          <th scope="col" className="mw-200 p-4">Owner</th> */}
                          {permissions?.isSave && <th scope="col" className="mw-200 p-4">Action</th>}
                        </tr>
                      </thead>

                      <tbody>
                        {currentRows.length > 0 ? (
                          currentRows.map((item, index, arr) => {
                            const showUpward = index >= arr.length - 2 && arr.length > 1;
                            return (
                             <tr
                               className="hover:bg-slate-50 transition-colors border-b border-slate-100 text-left"
                               key={index}
                             >
                              {permissions?.isDelete && (
                                <td className="w-4 px-4 py-3 ">
                                  <label className="custom-label">
                                    <div className="bg-white dark:bg-slate-600/40 border border-slate-200 dark:border-slate-600 rounded w-4 h-4 inline-block leading-4 text-center -mb-[3px]">
                                      <input
                                        type="checkbox"
                                        checked={selectedPepoleIds?.includes(item?.personMasterID)}
                                        onChange={() => handleCheckboxChange(item?.personMasterID)}
                                      />
                                    </div>
                                  </label>
                                </td>
                              )}
                              <td
                                className="mw-200 capitalize px-4 py-3 text-sm font-semibold text-slate-700 hover:text-indigo-600 cursor-pointer whitespace-nowrap"
                                onClick={() => navigate(`/detailsPeople/${item.personMasterID}`)}
                              >
                                {item.name}
                              </td>

                              <td className="mw-200 capitalize px-4 py-3 text-sm whitespace-nowrap ">
                                <span
                                  className="text-xs font-semibold px-2.5 py-0.5 rounded-full"
                                  style={{ backgroundColor: item.color + '20', color: item.color }}
                                >
                                  {item.labelName}
                                </span>
                              </td>
                              <td
                                className="mw-200 capitalize px-4 py-3 text-sm text-indigo-600 hover:text-indigo-800 cursor-pointer whitespace-nowrap "
                                onClick={() => navigate(`/detailsOrganization/${item.organizationID}`)}
                              >
                                {item.organizationName}
                              </td>
                              <td className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap ">
                                {item.personEmailDetails.map((x, idx) => (
                                  <div key={idx}>
                                    <p>{x.email}</p>
                                  </div>
                                ))}
                              </td>
                              <td className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap ">
                                {item.personPhoneDetails.map((x, idx) => (
                                  <div key={idx}>
                                    <p>{x.phoneNumber ? x.phoneNumber : ''}</p>
                                  </div>
                                ))}
                              </td>
                              <td className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap  font-medium text-green-600">
                                {item?.wonDeal}
                              </td>
                              <td className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap  font-medium text-red-500">
                                {item?.lostDeal}
                              </td>
                              <td className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap ">
                                {item?.closedDeal}
                              </td>
                              <td className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap  font-medium text-blue-600">
                                {item?.openDeal}
                              </td>
                              {/* <td className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap ">
                                {item?.doneActivity}
                              </td>
                              <td className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap ">
                                {item?.activitiesToDo}
                              </td>
                              <td className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap ">
                                {item?.totalActivities}
                              </td>
                              <td className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap ">
                                {item?.nextActivityDate ? FormatDateMoment(item?.nextActivityDate) : ''}
                              </td>
                              <td className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap ">
                                {FormatDateMoment(item?.createdDate)}
                              </td>
                              <td className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap ">
                                {item?.updatedDate ? moment(item?.updatedDate).format('LLL') : ''}
                              </td>
                              <td className="mw-200 px-4 py-3 text-sm text-slate-500 whitespace-nowrap  capitalize">
                                Dhruv
                              </td> */}
                              {permissions?.isSave && (
                                <td className="px-4 py-3  whitespace-nowrap">
                                  <div className="relative inline-block text-left">
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setOpenActionMenuId(openActionMenuId === item.personMasterID ? null : item.personMasterID);
                                      }}
                                      className="p-1.5 text-slate-500 hover:text-slate-800 hover:bg-slate-100 rounded-lg transition-colors"
                                    >
                                      <BsThreeDotsVertical size={16} />
                                    </button>
                                    {openActionMenuId === item.personMasterID && (
                                      <div className={`absolute right-0 w-36 bg-white border border-slate-100 rounded-lg shadow-lg py-1 z-50 animate-in fade-in duration-100 flex flex-col ${showUpward ? 'bottom-full mb-1 slide-in-from-bottom-1' : 'top-full mt-1 slide-in-from-top-1'}`}>
                                        <button
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setOpenModel(true);
                                            EditPerson(item.personMasterID);
                                            setOpenActionMenuId(null);
                                          }}
                                          className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors text-left"
                                        >
                                          <BiEdit size={14} className="text-indigo-500" />
                                          <span>Edit</span>
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </td>
                              )}
                            </tr>
                           ); })

                        ) : (
                          <tr>
                            <td colSpan="20" className="text-center px-4 py-4 text-slate-500">
                              Not Found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <Pagination setCurrentPage={setCurrentPage} handlePageChange={handlePageChange} currentPage={currentPage} sidebarOpen={sidebarOpen} totalPages={totalPages} length={filteredPeople.length} setrowsPerPage={setrowsPerPage} rowsPerPage={rowsPerPage} name='Person' />
                </>

              )}
            </div>
          </div>
        </div>
      </div>
      {openModel && (
        <AddEditPerson
          togglemodel={togglemodel}
          Person={Person}
          setLoadFirst={setloadFirst}
        />
      )}
    </>
  );
};

export default People;

